import {DataFetcher, useGrpcRequest} from '@aboutyou/data-fetcher';
import {CountryDetectionService_GetCountrySwitchLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/country_detection/v1/service.grpc.lazy';
import React, {FC} from 'react';
import {LanguageCountrySwitchView} from './LanguageCountrySwitchView';

export const LanguageCountrySwitch: FC<{
  className?: string;
  openAs: 'flyout' | 'popup';
}> = viewProps => {
  return (
    <DataFetcher
      request={useLanguageCountrySwitchData()}
      Error={null}
      Loading={undefined}
      View={LanguageCountrySwitchView}
      viewProps={viewProps}
    />
  );
};

const useLanguageCountrySwitchData = () => {
  return useGrpcRequest(CountryDetectionService_GetCountrySwitchLazy, {});
};
